export const ADVERTISING_CONSTS = {
    GET_ADVERTISING: "GET_ADVERTISING",
    GET_ADVERTISING_BY_ID: "GET_ADVERTISING_BY_ID",
    CREATE_ADVERTISING: "CREATE_ADVERTISING",
    UPDATE_ADVERTISING_POSITIONS: "UPDATE_ADVERTISING_POSITIONS",
    UPDATE_ADVERTISING_BY_ID: "UPDATE_ADVERTISING_BY_ID",
    DELETE_ADVERTISING_BY_ID: "DELETE_ADVERTISING_BY_ID",
};
